import { PropsWithChildren } from 'react';

import { QuoteContext } from './QuoteContextProvider.context';
import { QuoteContextState } from './QuoteContextProvider.types';

export type QuoteContextProviderValue = QuoteContextState;

export const QuoteContextProvider = <C extends QuoteContextState>({
  children,
  value,
}: PropsWithChildren<{ value: C }>) => {
  return <QuoteContext.Provider value={value}>{children}</QuoteContext.Provider>;
};
